/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';

const P = styled.p`
  font-family: 'Roboto', sans-serif;
  line-height: 150.2%;
`;

const HighlightedP = styled.p`
  font-family: 'Playfair Display', serif;
  font-weight: bold;
`;

export const HighlightedPLight = styled.p`
  font-family: 'Playfair Display', serif;
  font-size: 26px;
  line-height: 34,66px;
`;

interface Props {
  children: string | JSX.Element | JSX.Element[];
}

export const Paragraph = ({ children, ...props }: Props): JSX.Element => (
  <P {...props}>{children}</P>
);

export const HighlightedParagraph = ({ children, ...props }: Props): JSX.Element => (
  <HighlightedP {...props}>{children}</HighlightedP>
);
